const topics = [
  { name: '悬疑剧推荐', heat: '9.8万讨论', color: 'bg-accent-100 text-accent-800' },
  { name: '高分电影榜单', heat: '8.5万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '国产剧黑马', heat: '7.2万讨论', color: 'bg-secondary-100 text-secondary-800' },
  { name: '韩剧热门精选', heat: '6.9万讨论', color: 'bg-accent-100 text-accent-800' },
  { name: '纪录片口碑', heat: '5.6万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '动漫新番速递', heat: '5.3万讨论', color: 'bg-secondary-100 text-secondary-800' },
  { name: '动作大片合集', heat: '4.8万讨论', color: 'bg-accent-100 text-accent-800' },
  { name: '喜剧爆笑推荐', heat: '4.5万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '古装剧精选', heat: '4.1万讨论', color: 'bg-secondary-100 text-secondary-800' },
  { name: '科幻电影专题', heat: '3.8万讨论', color: 'bg-accent-100 text-accent-800' },
  { name: '治愈系日剧', heat: '3.4万讨论', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            大家都在聊的影视话题，加入讨论发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className={`group flex items-center gap-3 px-4 py-2.5 md:px-5 md:py-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 ${topic.color}`}
            >
              <i className="ri-hashtag text-sm opacity-60"></i>
              <span className="text-sm md:text-base font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-60 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}